import vars from '../helpers';
import {Router} from 'ninelines-router';
import {TimelineMax, TweenMax} from 'gsap';
import Preloader from './preloader';
import analytics from '../analytics';

let router = new Router();

let $html = $('html');

let animation = {
	index: {
		in(resolve) {
			new TimelineMax({
				onStart() {
					$('.page[data-page="index"]').removeClass('is-hidden').addClass('is-active');
					if ($('.index__scroll .swiper-container')[0].swiper) {
						$('.index__scroll .swiper-container')[0].swiper.update();
					}
				},
				onComplete() {
					resolve();
				},
			})
			.from($('.page[data-page="index"]'), 0.5, {
				autoAlpha: 0,
			});
		},
		out($page, resolve) {},
	},
	article: {
		in($page, resolve, delay = 0) {
			$html
				.data('page', 'article')
				.attr('data-page', 'article');

			new TimelineMax({
				onStart() {
					$page.removeClass('is-hidden').addClass('is-active');
					if ($page.find('.article__related .swiper-container')[0].swiper) {
						$page.find('.article__related .swiper-container')[0].swiper.slideTo(0, 0);
						$page.find('.article__related .swiper-container')[0].swiper.update();
					}
				},
				onComplete() {
					vars.saveScrollPosition();
					vars.$html.addClass('is-scroll-disabled');
					resolve();
				},
			})
				.from($page, 0.5, {
					y: '100%',
				}, delay);
		},
		out($page, resolve) {
			new TimelineMax({
				onStart() {
					vars.$html.removeClass('is-scroll-disabled');
					vars.$html.removeClass('is-show-menu is-burger-mix');
					vars.restoreScrollPosition();
				},
				onComplete() {
					$page.addClass('is-hidden').removeClass('is-active');
					TweenMax.set([$page], {clearProps: 'all'});

					resolve();
				},
			})
				.to($page, 0.5, {
					y: '100%',
				});
		},
	},
}

router.addRoute({
	path: '/',
	name: 'index',
	onEnter(prevState, currentState) {
		analytics.spentOnPage15sec();

		return new Promise((resolve) => {
			$html
				.data('page', 'index')
				.attr('data-page', 'index');

			if (!prevState.route) {
				Preloader(() => {
					animation.index.in(resolve);
				});
			}
		});
	},
	onLeave() {
		return new Promise((resolve) => {
			vars.$html.removeClass('is-show-menu is-burger-mix');
			resolve();
		});
	},
});

router.addRoute({
	path: '/article/:id',
	name: 'article',
	onEnter(prevState, currentState) {
		analytics.spentOnPage15sec();

		return new Promise((resolve) => {
			let $page = $(`.page[data-page="article"][data-id="${currentState.params.id}"]`);

			if (!$page.length) {
				router.trigger('notFound', [location.pathname]);
			} else if (prevState.route) {

				if(prevState.route.name === 'article') {
					$html
						.data('page', 'index')
						.attr('data-page', 'index');

					if (vars.isMobile()) {
						let $active = $('.index__scroll .swiper-slide').eq(currentState.params.id);

						$('html, body').animate({
							scrollTop: $active.offset().top + $active.outerHeight() / 2 - vars.$window.outerHeight() / 2,
						}, 500);
					} else {
						$('.index__scroll .swiper-container')[0].swiper.slideTo(parseInt(currentState.params.id, 10));
					}
					setTimeout(() => {
						animation.article.in($page, resolve);
					}, 1000);
				} else {
					animation.article.in($page, resolve, 0.15);
				}
			} else {
				Preloader(() => {
					new TimelineMax({
						onStart() {
							$('.page[data-page="index"]').removeClass('is-hidden').addClass('is-active');
							if (vars.isMobile()) {
								let $active = $('.index__scroll .swiper-slide').eq(currentState.params.id);

								$('html, body').animate({
									scrollTop: $active.offset().top + $active.outerHeight() / 2 - vars.$window.outerHeight() / 2,
								}, 500);
							} else {
								$('.index__scroll .swiper-container')[0].swiper.update();
								$('.index__scroll .swiper-container')[0].swiper.slideTo(parseInt(currentState.params.id, 10));
							}
						},
						onComplete() {
							setTimeout(() => {
								animation.article.in($page, resolve);
							}, 800);
						},
					})
					.from($('.page[data-page="index"]'), 0.5, {
						autoAlpha: 0,
					});
				});
			}
		});
	},
	onLeave(prevState) {
		return new Promise((resolve) => {
			let $page = $(`.page[data-page="article"][data-id="${prevState.params.id}"]`);

			let delay = 0;

			setTimeout(() => {
				animation.article.out($page, resolve);
			}, delay);
		});
	},
});

router.on('notFound', () => {
	router.navigate('/');
});

export default router;
